import { TRACK_ENGAGEMENT_COLLECTION } from './collections';

import { escapeTypesenseStringLiteral } from './stock-video-engagement-join';

/** Per-page engagement rank for music category and collection pages. */
export const TRACK_ENGAGEMENT_SORT = `$${TRACK_ENGAGEMENT_COLLECTION}(sort_score:desc)`;

/** A collection page's membership filter. Collections are hand-curated lists, not rules. */
export const getCollectionPageFilter = (collectionPath: string): string =>
  `collections:=["${escapeTypesenseStringLiteral(collectionPath)}"]`;

/**
 * `filter_by` for a music category/collection page: the page's membership
 * filter AND a left join onto its engagement rows.
 *
 * The join (`id:* || $trackEngagementV1(...)`) filters nothing — it only makes
 * `sort_score` sortable. Membership comes entirely from `pageFilter`, so a
 * missing one throws rather than silently returning the whole catalogue.
 */
export const withTrackEngagementFilter = ({
  pageFilter,
  slug,
  isPremium,
}: {
  pageFilter: string | null | undefined;
  slug: string;
  isPremium: boolean;
}): string => {
  if (!pageFilter?.trim()) {
    throw new Error(`No page filter for music page "${slug}"`);
  }

  const accountTypeGroup = isPremium ? 'paid' : 'free';

  return `(${pageFilter}) && (id:* || $${TRACK_ENGAGEMENT_COLLECTION}(account_type_group:=${accountTypeGroup} && slug:="${escapeTypesenseStringLiteral(slug)}"))`;
};

/**
 * The membership filter for a music category or collection page. Category
 * pages use the rule the API compiled (`pageFilter`) — never build one here.
 * Undefined means the page has no usable rule and must not be rendered.
 */
export const getMusicPageFilter = (
  pageFilter: string | null | undefined,
  contextPath: string
): string | undefined => {
  if (contextPath.includes('/collection/')) {
    return getCollectionPageFilter(contextPath);
  }

  return pageFilter?.trim() || undefined;
};
